import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, useHistory } from 'react-router-dom'

import moment from 'moment';
import { useTheme } from "./theme-provider.js"
import { Modal } from "react-bootstrap";
import uuid from 'react-uuid';
import { useAuthData } from "./auth-provider.js"

import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import Dropzone from 'react-dropzone-uploader';
import { Drawer, Pagination, Space, Tooltip } from 'antd';
import Select, { components } from 'react-select';
import formatNumber from '../common_component/formatNumber.js';
import StatusBadge from '../common_component/StatusBadge.js';
import PageError from '../common_component/PageError.js';
import TableColumnHead from "../common_component/TableColumnHead.js";
import { setCookie, getCookie } from '../common_component/cookie.js';

function ReceivedPaymentList() {
    const daterange_picker_ref = useRef();
    const history = useHistory();
    const [state, setstate] = useState(2);
    const [Calculation_info, setCalculation_info] = useState({ total_amount: 0, adjustable_amount: 0, payment_amount: 0 });

    const [navtype, setnavtype] = useState("Overview");
    const [Payment_details, setPayment_details] = useState(null);
    const [Payment_history_details, setPayment_history_details] = useState([]);
    const [Payment_document_details, setPayment_document_details] = useState([]);
    const [open, setOpen] = useState(false);
    const [additonalDetailsFlag, setAdditonalDetailsFlag] = useState(false);
    const [payment_received_id, setpayment_received_id] = useState("");
    const [payment_received_type, setpayment_received_type] = useState("");
    const [cancel_type, setcancel_type] = useState("");
    const [status, setstatus] = useState("");
    const [reason, setReason] = useState("");
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState('')
    const [totalPaymentListLength, setTotalPaymentListLength] = useState(0);
    const [paymentListApiState, setPaymentListApiState] = useState(false);

    let [fileNames, setFileNames] = useState([])
    const [fileSessionUniqueId, setFileSessionUniqueId] = useState(uuid());
    const [ImageModalShow, setImageModalShow] = useState(false);
    const [Image_src, setImage_src] = useState(false);

    const [RemoveAttachmentModalShow, setRemoveAttachmentModalShow] = useState(false);
    const [RemoveAttachmentDetails, setRemoveAttachmentDetails] = useState(null);

    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"));
    const [ReceivedPaymentList, setReceivedPaymentList] = useState([]);


    const { theme, dropdownStyleDark } = useTheme()
    const [baseCurrency, setBaseCurrency] = useState(null)

    const [statusModalShow, setStatusModalShow] = useState(false);
    const [statusType, setStatusType] = useState("All");
    const [documentType, setDocumentType] = useState({ label: "Invoice Payment", value: "Invoice Payment" });

    const [approveModalShow, setApproveModalShow] = useState(false);
    const [approveType, setApproveType] = useState("");

    const documentTypeArray = ["Invoice Payment", "Advance Payment"]
    const statusTypeArray = ["PAYMENT_DRAFT", "PAYMENT_PENDING_APPROVAL", "PAYMENT_CANCELLED", "PAYMENT_REJECTED", "PAYMENT_APPROVED_PAID"]
    const apiController = useRef(new AbortController())

    const presets = [
        { label: 'Today', start: new Date(), end: new Date() },
        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
    ];

    var page_name = "payment-received-list";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const onClose = () => {
        setOpen(false);
        setPayment_history_details([]);
        setPayment_document_details([]);
        setPayment_details(null);
    };

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    async function getReceivedPaymentList(start, end, page_number, Size, search_val, st, dt) {
        try {
            setReceivedPaymentList([]);
            if (paymentListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setPaymentListApiState(true);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/show-payment-received`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_val, "status_type": st, "document_type": dt, "page_name": page_name, "currentPage": page_number, "rows_per_page": Size, "start_date": start, "end_date": end, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation == "success") {
                if (body.data.list.length > 0) {
                    body.data.list.map((obj) => {
                        obj.approve_button_show = false;
                        obj.approve_final_button_show = false;

                        let t1 = JSON.parse(obj.approval_info)
                        let t2 = obj.add_status
                        let t3 = obj.approval_level
                        let t4 = t1.value.length
                        if (t2 == "PAYMENT_PENDING_APPROVAL") {
                            if (t1.type == "multilevel_approval") {

                                let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
                                if (tl.includes(user.email)) {
                                    obj.approve_button_show = true;
                                }
                            }
                            else if (t1.type == "custom_approval") {
                                let ty = t1.value[0]
                                if (ty.user_type == "Group User") {
                                    if (ty.user_value.includes(user_role)) {
                                        obj.approve_button_show = true;
                                    }
                                }
                                else if (ty.user_type == "Individual User") {
                                    if (ty.user_value.includes(user.email)) {
                                        obj.approve_button_show = true;
                                    }
                                }
                            }
                            if (user_role == "Admin") {
                                obj.approve_final_button_show = true;
                            }
                        }

                    })
                    setReceivedPaymentList(body.data.list);
                }
                else {
                    setReceivedPaymentList([]);
                }
            }
            setTotalPaymentListLength(body.data.count);
            setPaymentListApiState(false);
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getBaseCurrency() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.length > 0) {
            setBaseCurrency(body[0])
        }
    }


    async function getPaymentReceivedadditionalDetails(id, flag) {
        setAdditonalDetailsFlag(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/payment-received-additional-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "flag": flag, "document_flag": true, "history_flag": true, "id": id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setPayment_history_details(body.data.payment_received_history_details);
            setPayment_document_details(body.data.payment_received_document_details);
            setAdditonalDetailsFlag(false);
        }
        else {
            throw "collection additional details api error"
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getReceivedPaymentList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType, documentType.value);
            let p2 = getBaseCurrency();
            Promise.all([p1, p2])
                .then(() => {
                    setstate(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                    swal("Oops!", err, "error")
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getReceivedPaymentList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType, documentType.value)
        }
    }, [startDate, endDate, currentPage, rowsPerPage, searchValue, statusType, documentType.value])

    const setUpDrawer = (id, flag) => {
        let tempData = ReceivedPaymentList.find(option => option.unique_id == id)
        setOpen(true);
        setnavtype("Overview");
        setPayment_details(tempData);
        getPaymentReceivedadditionalDetails(id, flag)
        if(tempData.payment_type === "Invoice Payment")
        {
            calculatePaymentDetails(tempData.invoice_info);
        }
    }


    const calculatePaymentDetails = (invoiceArray) => {
        let total_amount = invoiceArray.reduce((p, o) => {
            if (!o.invoice_new) {
                return p + ((Number(o.invoice_currency.exchange_rate.organization.rate) / Number(o.invoice_currency.exchange_rate.invoice.rate)) * Number(o.payment_amount))
            }
            else {
                return p + Number(o.payment_amount);
            }
        }, 0);
        let adjustable_amount = invoiceArray.reduce((p1, o1) => {
            if (!o1.invoice_new) {
                return p1 + o1.adjust_amount_arr.reduce((p2, o2) => { return p2 + (Number(o1.invoice_currency.exchange_rate.organization.rate) / Number(o1.invoice_currency.exchange_rate.invoice.rate)) * Number(o2.adjustable_balance) }, 0);
            }
            else {
                return p1 + o1.adjust_amount_arr.reduce((p2, o2) => { return p2 + Number(o2.adjustable_balance) }, 0);
            }
        }, 0)
        let payment_amount = Number(total_amount) - Number(adjustable_amount);
        setCalculation_info({ "total_amount": total_amount, "adjustable_amount": adjustable_amount, "payment_amount": payment_amount });
    }

    const updateStatus = (id, type) => {
        for (let i = 0; i < ReceivedPaymentList.length; i++) {
            if (id == ReceivedPaymentList[i].unique_id) {
                setpayment_received_id(id);
                setpayment_received_type(ReceivedPaymentList[i].payment_type);
                setstatus(ReceivedPaymentList[i].add_status);
                if (type == "status") {
                    setStatusModalShow(true);
                }
                else {
                    setApproveModalShow(true);
                }

            }
        }
    }

    const submitStatus = (e) => {
        e.preventDefault();
        if (reason == "") {
            swal("Warning!", `Need a specific reason for Cancel/Reject`, "warning");
            return false;
        }
        var values = { "id": payment_received_id, "cancel_type": cancel_type, "save_flag": true, "reason": reason, "flag": payment_received_type, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-payment-received-details`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment received cancelled successfully!", "success").then((value) => {
                    setStatusModalShow(false);
                    getReceivedPaymentList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType, documentType.value);
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const showImage = (src) => {
        console.log(src);
        setImage_src(src);
        setImageModalShow(true);
    }

    const submitattachments = (val) => {
        var values = { "id": val, "unique_id": fileSessionUniqueId, 'filenames': fileNames, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-payment-received-document-details`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment Received attachments saved successfully!", "success").then((value) => {
                    setOpen(false);
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    function getExtension(path) {
        var basename = path.split(/[\\/]/).pop(),  // extract file name from full path ...
            // (supports `\\` and `/` separators)
            pos = basename.lastIndexOf(".");       // get last position of `.`

        if (basename === "" || pos < 1)            // if file name is empty or ...
            return "";                             //  `.` not found (-1) or comes first (0)

        return basename.slice(pos + 1);            // extract extension ignoring `.`
    }

    const Preview = ({ fileWithMeta: { remove }, meta }) => {
        const { name, percent, status, previewUrl } = meta;
        // console.log(name)
        return (

            <div className="preview-box">
                <img src={previewUrl} style={{ maxHeight: "80px", maxWidth: "80px", borderRadius: "4px", marginRight: "10px" }} />
                <span title={name} className="name">{name.length >= 10 ? name.slice(0, 10) + "...." : name}</span> - <span className="status">{(status === "done") ? "Successfully Uploaded" : status}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span> && <span className="dzu-previewButton remove" onClick={remove} >
                    <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                        <g>
                            <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                        </g>
                    </svg>
                </span>}
                {
                    status === "done" &&
                    <span className="dzu-previewButton remove" onClick={remove} >
                        <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                            <g>
                                <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                            </g>
                        </svg>
                    </span>
                }
            </div>
        )
    }

    const handleChangeStatus = ({ meta }, status, allFiles) => {
        const { name } = meta;

        if (status === 'done') {
            setMainSubmitButtonState(false)
            setFileNames([...fileNames, name])
        }
        else if (status === 'removed') {
            setMainSubmitButtonState(false)
            let temp = [...fileNames]
            temp.splice(temp.indexOf(name), 1)
            setFileNames(temp)
        }
        else if (status === "error_file_size") {
            allFiles[0].remove()
            swal("Oops!", "File size exceeded", "warning");
        }
    };

    const getUploadParams = ({ file }) => {

        const body = new FormData();
        body.append('dataFiles', file);
        body.append('unique_id', fileSessionUniqueId);
        body.append('organization_id', organization_id);
        body.append('user_id', user.email);
        body.append('page_name', page_name);

        let headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            "token": getCookie("access_token")
        }

        setMainSubmitButtonState(true)
        return { url: `${process.env.REACT_APP_SERVER_URL}/upload-payment-received-documents`, headers, body }
    }

    const removeattachments = (val) => {
        let image_id = RemoveAttachmentDetails.unique_id;
        let file_name = RemoveAttachmentDetails.file_name;
        let original_file_name = RemoveAttachmentDetails.original_file_name;
        var values = { "image_id": image_id, "file_name": file_name, "original_file_name": original_file_name, "folder": "payment_received_documents", "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/delete-payment-received-document`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment Received attachments removed successfully!", "success").then((value) => {
                    setRemoveAttachmentModalShow(false);
                    setOpen(false);
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const approvePaymentReceived = (e) => {
        e.preventDefault();

        var values = { "id": payment_received_id, "flag": payment_received_type, "user_role": user_role, "cancel_flag": false, "final_flag": approveType == "final_approve" ? true : false, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-payment-received-details`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment Receive Details Approved & paid Successfully!", "success").then((value) => {
                    setApproveModalShow(false);
                    getReceivedPaymentList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType, documentType.value);
                });
            }
            else if (res.data.message === "invoice_already_paid") {
                const flag = res.data.data.length === ReceivedPaymentList.find(option => option.unique_id == payment_received_id).invoice_info.length;
                swal({
                    text: `This ${res.data.data.join(",")} Invoice Number already paid.Do you want to cancel${!flag ? " or edit" : ""}?`,
                    icon: "warning",
                    buttons: {
                        close: { text: "Close", className: "btn btn-secondary" },
                        ...(!flag ?
                            {
                                edit: {
                                    text: "Yes, Edit",
                                    value: "edit",
                                    className: "btn btn-primary"
                                }
                            } : []
                        ),
                        cancel1: {
                            text: "Yes, Cancel",
                            value: "cancel",
                            className: "btn btn-danger"
                        }
                    },
                    dangerMode: true,
                })
                    .then((value) => {
                        if (value === "cancel") {
                            setcancel_type("cancelled");
                            updateStatus(payment_received_id, "status", status);
                        }
                        else if (value === "edit") {
                            history.push(`/edit-payment-received/${payment_received_id}`)
                        }
                    });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    return (
        <>

            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Payment Received List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/receive_payment`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <Link to={`/new-payment-received`} className="btn btn-sm btn-primary me-3 rounded">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
                                    </path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Create Payment Received</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {state == 1 ?
                        <>
                            <div className="row gx-0 gap-5 m-2">
                                <div className='col-md-3'>
                                    {(startDate !== "" && endDate != "") &&
                                        <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                            <DateRangePickerComponent
                                                ref={daterange_picker_ref}
                                                allowEdit={false}
                                                focus={(e) => {
                                                    //console.log(e);
                                                    daterange_picker_ref.current.show()
                                                }}
                                                delayUpdate={true}
                                                presets={presets}
                                                change={(e) => {
                                                    setStartDate(e.startDate);
                                                    setEndDate(e.endDate);
                                                }}
                                                startDate={startDate}
                                                endDate={endDate}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className='col-md-3'>
                                    <Select
                                        options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x.replace("PAYMENT", "").replace("_", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), value: x } })]}
                                        onChange={(event) => { setStatusType(event.value); }}
                                        value={statusType !== "All" ? statusTypeArray.find(elem => elem.value == statusType) : { label: "All", value: "All" }}
                                        placeholder="Select Status..."
                                        styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    />
                                </div>
                                <div className='col-md-3'>
                                    <Select
                                        options={documentTypeArray.map(x => { return { label: x, value: x } })}
                                        onChange={(event) => { setDocumentType(event); }}
                                        value={documentType}
                                        placeholder="Select Type..."
                                        styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    />
                                </div>
                            </div>
                            <div className="card mb-5 mb-xl-8">
                                <div className="card-body py-3">
                                    <div className='mb-5'>
                                        <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                    </div>

                                    <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                        {
                                            paymentListApiState ?
                                                <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                :
                                                ReceivedPaymentList.length > 0 ?
                                                    <>
                                                        <div className="mb-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={totalPaymentListLength}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>

                                                        <div className='overflow-auto w-100 flex-grow-1'>
                                                            <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                                <thead>
                                                                    <tr className="fw-bold text-muted">
                                                                        <th className="min-w-150px">Id</th>
                                                                        {documentType.value === "Invoice Payment" && <th className="min-w-150px">Invoices</th>}
                                                                        <th className="min-w-150px">Payment For</th>
                                                                        <th className="min-w-150px">Payment User</th>
                                                                        <th className="min-w-150px">Payment Type</th>
                                                                        <th className="min-w-150px">Amount</th>
                                                                        <th className="min-w-150px">Payment Date</th>
                                                                        <th className="min-w-150px">Status</th>
                                                                        <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        ReceivedPaymentList.map((obj3, indx3) => {
                                                                            return (
                                                                                <tr key={indx3}>
                                                                                    <td>
                                                                                        <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.transaction_number}</a>
                                                                                        <span className="text-muted fw-semibold text-muted d-block fs-7">Branch: {obj3.branch_name}</span>
                                                                                    </td>
                                                                                    {obj3.payment_type === "Invoice Payment" &&
                                                                                        <td>{obj3.invoice_info.slice(0, 2).map((invoiceNumber, i) => (<span key={i} className={`fw-semibold badge badge-secondary m-1`}>{invoiceNumber.invoice_number}</span>))}{obj3.invoice_info.length > 2 && <a onClick={(e) => { setUpDrawer(obj3.unique_id, obj3.payment_type); }}><span className="cursor-pointer text-primary">...View More</span></a>}</td>}
                                                                                    <td>
                                                                                        <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.payment_for}</a>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className="badge badge-primary">{obj3.payment_user_name}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className="badge badge-secondary">{obj3.payment_type}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        {obj3.payment_type === "Invoice Payment" ?
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{baseCurrency.currency_symbol}&nbsp;{formatNumber((obj3.invoice_info.reduce((p, o) => { return p + ((Number(o.invoice_currency.exchange_rate.organization.rate) / Number(o.invoice_currency.exchange_rate.invoice.rate)) * Number(o.payment_amount)) }, 0)), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</a> :
                                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.payment_received_currency.currency_symbol}&nbsp;{formatNumber(obj3.payment_amount, { ...formatNumberOptions, currencyFormat: obj3.payment_received_currency.format, decimalPlaces: obj3.payment_received_currency.decimal_place })}</a>}
                                                                                    </td>
                                                                                    <td>
                                                                                        <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj3.payment_date).format("ll")}</a>
                                                                                    </td>
                                                                                    <td>
                                                                                        <StatusBadge status={obj3.add_status} entity={"PAYMENT"} />
                                                                                    </td>
                                                                                    <td className="sticky-column">
                                                                                        <div className="dropdown">
                                                                                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                                <i className="fas fa-bars px-0"></i>
                                                                                            </button>
                                                                                            {write &&
                                                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                    <li className="py-1"><a onClick={(e) => { setUpDrawer(obj3.unique_id, obj3.payment_type); }} className={`dropdown-item cursor-pointer`} >View details</a></li>
                                                                                                    {(user_role == "Admin" && (obj3.add_status !== "PAYMENT_APPROVED_PAID" && obj3.add_status !== "PAYMENT_CANCELLED" && obj3.add_status !== "PAYMENT_REJECTED")) &&
                                                                                                        <li className="py-1"><a onClick={(e) => { setcancel_type("cancelled"); updateStatus(obj3.unique_id, "status"); }} style={{ cursor: "pointer" }} className={`dropdown-item cursor-pointer`}>Cancel</a></li>}
                                                                                                    {(user_role == "Admin" && (obj3.add_status !== "PAYMENT_APPROVED_PAID" && obj3.add_status !== "PAYMENT_CANCELLED" && obj3.add_status !== "PAYMENT_REJECTED")) &&
                                                                                                        <li className="py-1"><a onClick={(e) => { setcancel_type("rejected"); updateStatus(obj3.unique_id, "status"); }} className={`dropdown-item cursor-pointer`}>Reject</a></li>}
                                                                                                    {(obj3.approve_final_button_show) &&
                                                                                                        <li className="py-1"><a onClick={(e) => { setApproveType("final_approve"); updateStatus(obj3.unique_id, "approve"); }} className={`dropdown-item cursor-pointer`}>Final Approve & Paid</a></li>}
                                                                                                    {(obj3.approve_button_show) &&
                                                                                                        <li className="py-1"><a onClick={(e) => { setApproveType("approve"); updateStatus(obj3.unique_id, "approve"); }} className={`dropdown-item cursor-pointer`}>Approve</a></li>}
                                                                                                    {(obj3.add_status === "PAYMENT_DRAFT" || obj3.add_status == "PAYMENT_PENDING_APPROVAL") &&
                                                                                                        <>
                                                                                                            <li className="py-1"><a href={`/edit-payment-received/${obj3.unique_id}`} className={`dropdown-item cursor-pointer`}>Edit Details</a></li>
                                                                                                        </>
                                                                                                    }
                                                                                                </ul>
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="mt-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={totalPaymentListLength}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-muted fs-2 my-auto text-center">No data to be shown</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        state == 2 ?
                            <>
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                            </>
                            :
                            state == 3 &&
                            <PageError />

                    }
                </div>
            </div>


            <Modal show={approveModalShow} onHide={() => { setApproveModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>{approveType === "final_approve" && <>Final</>} Approve Payment Received</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setApproveModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <div className="form-group row">
                            <div className="col-lg-12">
                                Current Status is :<StatusBadge status={status} entity={"PAYMENT"} />
                                <h3 className="mt-3">Are you sure about Approve {approveType === "final_approve" && <>& Paid</>} Payment Received?</h3>
                            </div>
                        </div>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setApproveModalShow(false) }} className="btn btn-secondary">Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { approvePaymentReceived(e) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">Approve {approveType === "final_approve" && <>& Paid</>}</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={statusModalShow} onHide={() => { setReason(""); setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>{cancel_type == "cancelled" ? <>Cancel Payment Received</> : <>Reject Payment Received</>}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setReason(""); setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className="text-center">
                            Current Status is : <StatusBadge status={status} entity={"PAYMENT"} /><br />
                            <h3 className="mt-3">Are you sure about {cancel_type == "cancelled" ? <>Cancelling Payment Received</> : <>Rejecting Payment Received</>}?</h3>
                        </div>
                        <div className="mt-2">
                            <label className="fs-5 fw-bold mb-2">Reason :</label>
                            <textarea className="form-control form-control-solid" rows="3" value={reason}
                                onChange={(e) => {
                                    setReason(e.target.value);
                                }}
                                placeholder={""}>
                            </textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setReason(""); setStatusModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={RemoveAttachmentModalShow} onHide={() => { setRemoveAttachmentModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Delete Payment Received Attachments</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setRemoveAttachmentModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure you want to delete this Payment Received Attachments?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setRemoveAttachmentModalShow(false) }} className="btn btn-secondary">Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { removeattachments(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Delete</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={ImageModalShow} onHide={() => { setImageModalShow() }} centered>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setImageModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container px-1 d-flex justify-content-center'>
                        <img src={Image_src} className='w-100 rounded' />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setImageModalShow(false) }} className="btn btn-secondary">Close</button>
                </Modal.Footer>
            </Modal>
            <Drawer
                title={(Payment_details != null && Payment_details.dcr_number != undefined) ? <>{Payment_details.dcr_number}</> : (Payment_details != null && Payment_details.pdcr_number != undefined) && <>{Payment_details.pdcr_number}</>} width={window.innerWidth > 1200 ? 800 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
                </a>}
                extra={
                    <Space>
                        {(Payment_details != null && write && (Payment_details.add_status == "PAYMENT_DRAFT" || Payment_details.add_status == "PAYMENT_PENDING_APPROVAL" || Payment_details.approve_final_button_show || Payment_details.approve_button_show)) &&
                            <div className="dropdown">
                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fas fa-bars px-0"></i>
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {(Payment_details.add_status === "PAYMENT_DRAFT" && Payment_details.add_status === "PAYMENT_PENDING_APPROVAL") &&
                                        <>
                                            <li className="py-1"><a href={`/edit-payment-received/${Payment_details.unique_id}`} className={`dropdown-item cursor-pointer`}>Edit Details</a></li>
                                        </>
                                    }
                                    {(user_role == "Admin" && (Payment_details.add_status !== "PAYMENT_APPROVED_PAID" && Payment_details.add_status !== "PAYMENT_CANCELLED" && Payment_details.add_status !== "PAYMENT_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { setcancel_type("cancelled"); updateStatus(Payment_details.unique_id, "status"); }} className={`dropdown-item cursor-pointer`}>Cancel</a></li>}
                                    {(user_role == "Admin" && (Payment_details.add_status !== "PAYMENT_APPROVED_PAID" && Payment_details.add_status !== "PAYMENT_CANCELLED" && Payment_details.add_status !== "PAYMENT_REJECTED")) &&
                                        <li className="py-1"><a onClick={(e) => { setcancel_type("rejected"); updateStatus(Payment_details.unique_id, "status"); }} className={`dropdown-item cursor-pointer`}>Reject</a></li>}
                                    {(Payment_details.approve_final_button_show) &&
                                        <li className="py-1"><a onClick={(e) => { setApproveType("final_approve"); updateStatus(Payment_details.unique_id, "approve"); }} className={`dropdown-item cursor-pointer`}>Final Approve & Paid</a></li>}
                                    {(Payment_details.approve_button_show) &&
                                        <li className="py-1"><a onClick={(e) => { setApproveType("approve"); updateStatus(Payment_details.unique_id, "approve"); }} className={`dropdown-item cursor-pointer`}>Approve</a></li>}
                                </ul>
                            </div>}
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            {(Payment_details != null && Payment_details.payment_type == "Invoice Payment") &&
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Invoice Info</a>
                                </li>}
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Attachments" && "active"}`} onClick={(e) => { setnavtype("Attachments"); }}>Attachments</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {(navtype === "Overview" && Payment_details !== null) ?
                        <>
                            <div
                                className="card border-primary mb-3 mt-2"
                                style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                            >
                                <div className="card-header cursor-pointer py-3">
                                    <div className="card-title m-0">
                                        <h3 className="fw-bold m-0">
                                            {Payment_details.transaction_number}
                                        </h3>
                                    </div>
                                </div>
                                <div className="card-body p-3">
                                    <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                        <h5 className="fw-bold mb-3">Basic Details</h5>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Type</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">
                                                    {Payment_details.payment_type}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Payment For</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">
                                                    {Payment_details.payment_for}
                                                </span>
                                            </div>
                                        </div>
                                        {Payment_details.payment_type == "Invoice Payment" ?
                                            <>
                                                {(Calculation_info.total_amount > 0 && Calculation_info.adjustable_amount > 0) &&
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Total Amount</label>
                                                        <div className="col-lg-8">
                                                            {Payment_details.payment_type === "Invoice Payment" ?
                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                    {baseCurrency.currency_symbol}&nbsp;{formatNumber(Calculation_info.total_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                                                </span> :
                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                    {Payment_details.payment_received_currency.currency_symbol}&nbsp;{formatNumber(Payment_details.payment_amount, { ...formatNumberOptions, currencyFormat: Payment_details.payment_received_currency.format, decimalPlaces: Payment_details.payment_received_currency.decimal_place })}
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>}
                                                {Calculation_info.adjustable_amount > 0 &&
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Adjustable Amount</label>
                                                        <div className="col-lg-8">
                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                {baseCurrency.currency_symbol}&nbsp;{formatNumber(Calculation_info.adjustable_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                                            </span>
                                                        </div>
                                                    </div>}
                                                {Calculation_info.payment_amount > 0 &&
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Payment Amount</label>
                                                        <div className="col-lg-8">
                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                {baseCurrency.currency_symbol}&nbsp;{formatNumber(Calculation_info.payment_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                                            </span>
                                                        </div>
                                                    </div>}
                                            </>
                                            :
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Payment Amount</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        {baseCurrency.currency_symbol}&nbsp;{formatNumber(Payment_details.payment_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Payment User</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">
                                                    {Payment_details.payment_user_name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Payment Date</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">
                                                    {moment(Payment_details.payment_date).format("ll")}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">
                                                    {Payment_details.branch_name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                            <div className="col-lg-8">
                                                <StatusBadge status={Payment_details.add_status} entity={"PAYMENT"} />
                                            </div>
                                        </div>
                                    </div>
                                    {Payment_details.payment_type !== "Invoice Payment" &&
                                        <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px" }}>
                                            <h5 className="fw-bold mb-3">Other Details </h5>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Billing Address</label>
                                                <div className="col-lg-8">
                                                    {Payment_details.billing_address !== null &&
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {`${Payment_details.billing_address.state && Payment_details.billing_address.state},${Payment_details.billing_address.city}, ${Payment_details.billing_address.pincode},${Payment_details.billing_address.country}`}
                                                        </span>}
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Shipping Address</label>
                                                <div className="col-lg-8">
                                                    {Payment_details.shipping_address !== null &&
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {`${Payment_details.shipping_address.state != undefined && Payment_details.shipping_address.state},${Payment_details.shipping_address.city}, ${Payment_details.shipping_address.pincode}, ${Payment_details.shipping_address.country}`}
                                                        </span>}
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Tax Details</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        {(Payment_details.gstin_details != null && Payment_details.gstin_details.gst_treatment == "Unregistered Business") ?
                                                            <span className="fw-semibold text-gray-800 fs-6">{`${Payment_details.gstin_details.GstIn},${Payment_details.gstin_details.gst_treatment}`}</span>
                                                            :
                                                            (Payment_details.gstin_details != null && Payment_details.gstin_details.gst_treatment == "Registered Business") &&
                                                            <span className="fw-semibold text-gray-800 fs-6">{`${Payment_details.gstin_details.GstIn},${Payment_details.gstin_details.gst_treatment}`}</span>
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </>
                        :
                        navtype === "Transactions" ?
                            <>
                                <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                    <div className="card-header cursor-pointer py-3">
                                        {Payment_details != null &&
                                            <div className="card-title m-0">
                                                <h3 className="fw-bold m-0">
                                                    Transaction Status : <StatusBadge status={Payment_details.add_status} entity={"PAYMENT"} />
                                                </h3>
                                            </div>}
                                    </div>
                                    {Payment_details != undefined &&
                                        <div className="card-body p-9">
                                            <div>
                                                {
                                                    Payment_details.invoice_info.map((payment, indx3) => {
                                                        return (
                                                            <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Invoice No.</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {payment.invoice_number}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Account</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {payment.deposit_through_account_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Invoice Date</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {moment(payment.invoice_date).format("ll")}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Payment Mode</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {payment.payment_mode}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Invoice Amount</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {payment.invoice_currency.currency_symbol} {payment.invoice_amount}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Payment Amount</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {payment.invoice_currency.currency_symbol} {payment.payment_amount}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Billing Address</label>
                                                                    <div className="col-lg-8">
                                                                        {payment.billing_address !== null &&
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {`${payment.billing_address.state && payment.billing_address.state},${payment.billing_address.city}, ${payment.billing_address.pincode},${payment.billing_address.country}`}
                                                                            </span>}
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Shipping Address</label>
                                                                    <div className="col-lg-8">
                                                                        {payment.shipping_address !== null &&
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {`${payment.shipping_address.state != undefined && payment.shipping_address.state},${payment.shipping_address.city}, ${payment.shipping_address.pincode}, ${payment.shipping_address.country}`}
                                                                            </span>}
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Tax Details</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {(payment.gstin_details != null && payment.gstin_details.gst_treatment == "Unregistered Business") ?
                                                                                <span className="fw-semibold text-gray-800 fs-6">{`${payment.gstin_details.gst_treatment}`}</span>
                                                                                :
                                                                                (payment.gstin_details != null && payment.gstin_details.gst_treatment == "Registered Business") &&
                                                                                <span className="fw-semibold text-gray-800 fs-6">{`${payment.gstin_details.GstIn},${payment.gstin_details.gst_treatment}`}</span>
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                            :
                            navtype === "Attachments" ?
                                <>
                                    {/* <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                    <div className="card-title m-0">
                                    Attachments
                                    </div>
                                </div> */}
                                    {Payment_details != undefined &&
                                        <div className="card-body p-9">
                                            {Payment_document_details.length > 0 &&
                                                <div className="overflow-auto pb-5">
                                                    <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7">
                                                        {additonalDetailsFlag !== true ?
                                                            <>
                                                                {Payment_document_details.map((obj, index) => {
                                                                    return (
                                                                        <>
                                                                            {/* {console.log(getExtension(obj.file_name))} */}
                                                                            {getExtension(obj.file_name) == "pdf" ?
                                                                                <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                                                                                    <img alt="" className="w-30px me-3" src="/assets/media/svg/files/pdf.svg" />
                                                                                    <div className="ms-1 fw-semibold">
                                                                                        <a target="_blank" href={(`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/payment_received_documents/${organization_id}/`, (obj.file_name))} className="fs-6 text-hover-primary fw-bold">{obj.original_file_name.substring(0, obj.original_file_name.lastIndexOf('.'))}</a>
                                                                                        <div className="text-gray-400">1.9mb</div>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <div className="overlay me-10">
                                                                                    <div className="overlay-wrapper">
                                                                                        <img alt="img" className="rounded w-150px" src={(`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/payment_received_documents/${organization_id}/`, (obj.file_name))} />
                                                                                    </div>
                                                                                    <div className="overlay-layer bg-dark bg-opacity-10 rounded">
                                                                                        <a onClick={() => showImage((`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/payment_received_documents/${organization_id}/`, (obj.file_name)))} className="btn btn-sm btn-primary btn-shadow me-1">View</a>
                                                                                        <a onClick={() => { setRemoveAttachmentDetails(obj); setRemoveAttachmentModalShow(true) }} className="btn btn-sm btn-danger btn-shadow">Delete</a>
                                                                                    </div>
                                                                                </div>}
                                                                        </>
                                                                    )
                                                                })}
                                                            </>
                                                            :
                                                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            <div className="mb-2">
                                                <Dropzone
                                                    getUploadParams={getUploadParams}
                                                    onChangeStatus={handleChangeStatus}
                                                    //LayoutComponent={CustomLayout}
                                                    PreviewComponent={Preview}
                                                    styles={{
                                                        dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                                        inputLabelWithFiles: { margin: '20px 3%' }
                                                    }}
                                                    maxFiles={3}
                                                    maxSizeBytes={1024 * 1024 * 2}
                                                    accept="image/*,.pdf"
                                                />
                                            </div>
                                            {fileNames.length > 0 &&
                                                <div className="text-end mb-1">
                                                    <button type="button" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={(e) => submitattachments(Payment_details.unique_id)} className="btn btn-sm btn-primary me-2">
                                                        <span className="indicator-label">Save</span>
                                                        <span className="indicator-progress">Please wait...
                                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                                                </div>
                                            }
                                        </div>
                                    }
                                </>
                                :
                                navtype === "History" &&
                                <>
                                    {Payment_details != undefined &&
                                        <div className="card-body p-9">
                                            {additonalDetailsFlag !== true ?
                                                <>
                                                    {Payment_history_details.length > 0 && Payment_history_details.map((obj, index) => {
                                                        return (
                                                            <>
                                                                <div className="m-0" key={index}>
                                                                    <div className="d-flex align-items-sm-center mb-5">
                                                                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                            <div className="flex-grow-1 me-2">
                                                                                <StatusBadge status={obj.payment_status} entity={"PAYMENT"} />
                                                                                {(obj.payment_status === "PAYMENT_PENDING_APPROVAL" || obj.payment_status === "PAYMENT_DRAFT") && <span className="badge badge-light-primary">{obj.operation == "create" ? <>Create</> : <>Update</>}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="timeline">
                                                                        <div className="timeline-item align-items-center mb-7">
                                                                            <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                            </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">Log Date</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{moment(obj.timestamp).format("lll")} </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline-item align-items-center">
                                                                            <div className="timeline-line w-40px"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                            </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{obj.user}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {Payment_history_details.length > 1 &&
                                                                    <div className="separator separator-dashed my-6"></div>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </>
                                                :
                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                            }
                                        </div>
                                    }
                                </>
                    }
                </div>
            </Drawer >
        </>
    );
}
export default ReceivedPaymentList;